import { IconButton } from "@mui/material";

import { UserAvatar } from "@/common/components/user-avatar/UserAvatar";
import { useCurrentUserContext } from "@/common/contexts/current-user-context/CurrentUserContext.ts";
import { useTranslation } from "@/translations";

import { UserDropdownAvatarProps } from "./UserDropdownAvatar.types";

export function UserDropdownAvatar(props: UserDropdownAvatarProps) {
  const { t } = useTranslation();
  const { currentUser } = useCurrentUserContext();

  return (
    <IconButton
      onClick={props.onClick}
      aria-label={t("common.openUserSettings", { userName: currentUser.userCode })}
      aria-haspopup="true"
      sx={{ p: 0 }}
    >
      <UserAvatar label={currentUser.userCode} />
    </IconButton>
  );
}
